import css from "styled-jsx/css";

export const componentStyles = css`
  .tag-component {
    font-size: 19px;
    padding: 8px 16px;
  }
`;
